import * as Sentry from "@sentry/react";

const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  integrations: isIOS ? [] : [Sentry.replayIntegration()],

  // Don't record normal sessions
  replaysSessionSampleRate: 0,

  // Record a replay for every session that has an error
  replaysOnErrorSampleRate: isIOS ? 0 : 1.0,

  // Reference a release
  release: import.meta.env.VITE_SENTRY_RELEASE,
});

Sentry.addBreadcrumb({
  category: "portal.sentry",
  level: "info",
  message: "Sentry initialized",
  data: {
    replayEnabled: !isIOS,
    isIOS,
  },
});
